// extracted by mini-css-extract-plugin
export default {"open_content":"OpenTop_open_content_Mj9ay","open_content_body":"OpenTop_open_content_body_Bmn4f"};